import { motion } from "framer-motion";
import { fadeUp, viewport } from "@/lib/motion";
import { FAQS } from "@/lib/data";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";

export const FAQ = () => {
  return (
    <section id="faq" data-testid="faq-section" className="py-24 md:py-36">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20">
          <div className="lg:col-span-4">
            <motion.p variants={fadeUp} initial="hidden" whileInView="show" viewport={viewport}
              className="text-xs font-semibold tracking-[0.25em] uppercase text-gold mb-6">FAQ</motion.p>
            <motion.h2 variants={fadeUp} initial="hidden" whileInView="show" viewport={viewport} custom={1}
              className="font-serif font-light text-4xl sm:text-5xl leading-tight text-primary">
              Questions, answered.
            </motion.h2>
          </div>

          <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={viewport} custom={2}
            className="lg:col-span-8">
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {FAQS.map((f, i) => (
                <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`} className="border-border">
                  <AccordionTrigger className="text-left font-serif text-xl md:text-2xl font-normal text-primary hover:no-underline hover:text-gold py-6">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-base font-light leading-relaxed text-muted-foreground pb-6">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
